// import ArticleDataOutputApi from '../../plugins/article-data-output-api.js';

// $("#age_article_list").ArticleDataOutputApi({
//   group: "nnp",
//   type: "theme",
//   slug: "new_immigration_age",
//   limit: 5,
//   layout: "simple",
// });
